import {
    convertCentsIntoDollar,
    formatDate,
} from "../../../../helpers/genericHelper";

export const nestedColumns = [
    {
        title: "Plaid Account ID",
        dataIndex: "plaidAccountId",
        key: "plaidAccountId",
    },
    {
        title: "Access Token",
        dataIndex: "accessToken",
        key: "accessToken",
    },
    {
        title: "Sila Fail Reason",
        dataIndex: "silaFailReason",
        key: "silaFailReason",
    },
    {
        title: "Last Updated",
        dataIndex: "updateTs",
        key: "updateTs",
        render: (val) => <p>{formatDate(val, true)}</p>,
    }
];
export const mainColumns = [
    {
        title: "ID",
        dataIndex: "id",
        key: "id",
        render: (text, record) =>
            record.accountState === "REJECTED" ? text.slice(0, 8) : text,
    },
    {
        title: "Bank Name",
        dataIndex: "bankName",
        key: "bankName",
    },
    {
        title: "Last 4",
        dataIndex: "last4",
        key: "last4",
    },
    {
        title: "Account State",
        dataIndex: "accountState",
        key: "accountState",
    },
    {
        title: "Primary",
        dataIndex: "isActive",
        key: "isActive",
        render: (val) => (val === true || val === false ? val.toString() : "")
    },
    {
        title: "Fail Reasons",
        dataIndex: "failReasons",
        key: "failReasons",
        render: (failReasons) => (
            <ul>
                {failReasons.map((reason, index) => (
                    <li key={index}>{reason}</li>
                ))}
            </ul>
        ),
    },
    {
        title: "Created",
        dataIndex: "createTs",
        key: "createTs",
        render: (val) => <p>{formatDate(val, true)}</p>,
    },
    {
        title: "Deleted",
        dataIndex: "deletedTs",
        key: "deletedTs",
        render: (val) => <p>{formatDate(val, true)}</p>,
    },
    {
        title: "Expired",
        dataIndex: "expiredTs",
        key: "expiredTs",
        render: (val) => <p>{formatDate(val, true)}</p>,
    },
    {
        title: "Cached Balance",
        dataIndex: "cachedBalance",
        key: "cachedBalance",
        render: (val) => <p>{convertCentsIntoDollar(val)}</p>,
    },
];
